import React from "react";

const Input = ({ name, label, error, ...rest }) => {
  return (
    <div className="form-group">
      <input
        {...rest}
        placeholder={label}
        name={name}
        id={name}
        maxLength={255}
        className="form-control"
      />
      {error && <div className="alert alert-danger">Partner is required</div>}
    </div>
  );
};

export default Input;
